import React from 'react'
import usePageMeta from '../hooks/usePageMeta'
import Navbar from '../components/navbar/Navbar'
import Footer from '../components/footer/Footer'
import Contact from '../components/contact/Contact'

export default function ContactPage() {
  usePageMeta({
    title: 'Contact & Location | Learning In Motion Preschool, Cooper City FL',
    description: 'Visit Learning In Motion Preschool at 10945 Stirling Road, Cooper City, FL 33328. Call 954-434-9620 to schedule a tour. Open 6:30am-6:30pm.',
    path: '/contact',
  })

  return (
    <>
      <Navbar/>
      <Contact/>
      <Footer/>
    </>
  )
}
